import { render, staticRenderFns } from "./LastRegisters.vue?vue&type=template&id=f233d750&scoped=true&"
import script from "./LastRegisters.vue?vue&type=script&lang=js&"
export * from "./LastRegisters.vue?vue&type=script&lang=js&"
import style0 from "./LastRegisters.vue?vue&type=style&index=0&id=f233d750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f233d750",
  null
  
)

export default component.exports